import { render, staticRenderFns } from "./medication-form.vue?vue&type=template&id=7058ff38&scoped=true"
import script from "./medication-form.vue?vue&type=script&lang=js"
export * from "./medication-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7058ff38",
  null
  
)

export default component.exports